export const apiEndPoints = {
  login: "auths/login",
  getAllProfiles: "companies/getAllCompanies",
  getProfilesByUserId: "companies/getCompanies",
  getFoamDataByProfile: "companys/getCompany/",
};
